import React, {Key, useEffect, useRef, useState} from "react";
import {Wrapper1} from "../../../wrapper/Wrapper1";
import {SECOND_COLOR} from "../../../../constans/colors";
import {Button, Divider, Flex, Form, Modal, Space, Table, TableProps} from "antd";
import {ColumnsType} from "antd/es/table";
import {
    openErrorNotification,
    openSuccessNotificationByMessage,
    Page,
    toPersianDateTime
} from "../../../../services/UtilFunctions";
import {FileType, FileTypeTitle} from "../../../../constans/enums";
import FileService, {SavedFile} from "../../../../services/FileService";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import ChunkFileUploader from "../../../common/ChunkFileUploader";
import TextArea from "antd/es/input/TextArea";
import {User} from "../../../../services/UserService";
import {SorterResult} from "antd/lib/table/interface";

const baseNonVideoUrl = process.env.REACT_APP_BASE_NON_VIDEO_URL || "";

const defaultParams = {
    pageNumber: 0,
    pageSize: 10,
    types: [FileType.TEACHER_FILES, FileType.TRANSFER_FILES],
    sortKey: "createdDate",
    sort: "DESC"
};

export const FileManagementContainer: React.FC = () => {

    const [data, setData] = useState<Page<SavedFile>>();
    const [params, setParams] = useState(defaultParams);
    const [show, setShow] = useState<boolean>(false);
    const [selectedDescription, setSelectedDescription] = useState<string>();
    const [deleteModal, deleteModalContextHolder] = Modal.useModal();
    const [dataLoading, setDataLoading] = useState<boolean>(false);
    const fileUploaderRef = useRef<any>(null);
    const [filePath, setFilePath] = useState<string | null>(null);
    const [form] = Form.useForm();
    const [submitFormLoading, setSubmitFormLoading] = useState<boolean>(false);


    useEffect(() => {
        loadData();
    }, [params]);

    const loadData = () => {
        setDataLoading(true);
        FileService.getSavedFilesForAdmin(params).then(page => {
            setData(page)
        }).finally(() => setDataLoading(false));
    }

    const handleSelectPagination = (page: number, pageSize: number) => {
        setParams({
            ...params,
            pageNumber: page - 1,
            pageSize: pageSize
        });
    };

    const onFinishSendFile = (values: any) => {
        if (!filePath) {
            openErrorNotification("لطفا فایل را آپلود کنید.");
            return;
        }
        values.filePath = filePath;
        setSubmitFormLoading(true);
        FileService.uploadTransferFiles(values).then(page => {
            openSuccessNotificationByMessage('فایل با موفقیت آپلود شد.');
            loadData();
            form.resetFields();
            if (fileUploaderRef.current) fileUploaderRef.current.reset();
            setFilePath(null);
        }).finally(() => setSubmitFormLoading(false));
    }

    const columns: ColumnsType<SavedFile> = [
        {
            title: 'نام کاربر',
            dataIndex: 'userFullName',
            width: 200,
            render: (_, {user}) => (
                <>{user && user.firstName + " " + user.lastName}</>
            ),
        },
        {
            title: 'تاریخ ارسال',
            dataIndex: 'createdDate',
            width: 200,
            render: (_, {createdDate}) => (
                <>{toPersianDateTime(createdDate)}</>
            ),
        },
        {
            title: 'نوع',
            dataIndex: 'type',
            width: 100,
            render: (_, {type}) => (
                <>{type && FileTypeTitle[type]}</>
            ),
            filters: [
                {
                    text: FileTypeTitle[FileType.TEACHER_FILES],
                    value: FileType.TEACHER_FILES,
                },
                {
                    text: FileTypeTitle[FileType.TRANSFER_FILES],
                    value: FileType.TRANSFER_FILES,
                }
            ],
        },
        {
            title: 'نام فایل',
            dataIndex: 'fileName',
            width: 200,
        },
        {
            title: 'توضیحات',
            dataIndex: 'description',
            width: 100,
            render: (_, {description}) => (
                description && <a onClick={event => {
                    setSelectedDescription(description);
                    setShow(true);
                }}>مشاهده</a>
            ),
        },
        {
            width: 70,
            render: (_, {fileId, fileName}) => (
                fileId && fileName ?
                    <Space size="large">
                        <a target='_blank' href={baseNonVideoUrl + "/" + fileId + "/" + fileName}>دانلود</a>

                        <a style={{color: 'red'}} onClick={() => {
                            deleteModal.confirm({
                                title: 'آیا می خواهید این فایل را حذف کنید؟',
                                icon: <ExclamationCircleOutlined/>,
                                okText: 'بله',
                                cancelText: 'انصراف',
                                okButtonProps: {danger: true},
                                onOk: () => {
                                    FileService.delete("/" + fileId + "/" + fileName).then(value => {
                                        loadData();
                                    })
                                }
                            })
                        }}>حذف</a>
                    </Space>
                    : null
            ),
        }

    ];

    const onChangeTable: TableProps<SavedFile>['onChange'] = (pagination, filters, sorter, extra) => {

        // sortField: sorter.field ? fieldNameMap[sorter.field] : null, // Map the field name
        //     sortOrder: sorter.order === 'ascend' ? 'asc' : sorter.order === 'descend' ? 'desc' : null,

        const sortKey = (sorter as SorterResult<any>)?.field as Key;

        let sort: string | null = null;
        if ((sorter as SorterResult<User>).order) {
            if ((sorter as SorterResult<User>).order === 'ascend') {
                sort = 'ASC';
            } else {
                sort = 'DESC';
            }
        }

        setParams({
            ...params,
            pageNumber: (pagination.current ?? 1) - 1,
            pageSize: pagination.pageSize ?? 10,
            sortKey: (sort && sortKey) ? sortKey + "" : defaultParams.sortKey,
            sort: sort ? sort : defaultParams.sort,
            types: filters.type ? filters.type.map(v => FileType[v as keyof typeof FileType]) : defaultParams.types
        });
    };

    return (
        <>
            <Wrapper1 style={{margin: "15px", marginTop: "0px", padding: "20px"}}>
                <div style={{color: SECOND_COLOR, fontSize: "18px", fontWeight: 'bold'}}>ارسال فایل</div>
                <Divider style={{margin: '0', marginTop: '15px', marginBottom: '15px'}}/>
                <ChunkFileUploader ref={fileUploaderRef} title="انتخاب فایل" maxSizeMb={2000}
                                   onUploadComplete={filePath => setFilePath(filePath)} onRemove={() => setFilePath(null)}/>
                <Form
                    style={{marginTop:'10px'}}
                    form={form}
                    name="basic"
                    onFinish={onFinishSendFile}
                    autoComplete="off"
                >
                    <Form.Item name="description"
                               labelCol={{span: 24}} label="توضیحات"><TextArea name="description"
                                                                               rows={4}/></Form.Item>
                    <Flex justify='end'>
                        <Form.Item>
                            <Button type="primary" htmlType="submit"
                                    loading={submitFormLoading}>ارسال</Button>
                        </Form.Item>
                    </Flex>
                </Form>
            </Wrapper1>
            <Wrapper1 style={{margin: "15px", marginTop: "0px", padding: "20px"}}>
                <div style={{color: SECOND_COLOR, fontSize: "18px", fontWeight: 'bold'}}>مدیریت فایل ها</div>
                <Divider style={{margin: '0', marginTop: '15px'}}/>
                <Table
                    locale={
                     {
                         filterConfirm:'تایید',
                         filterReset: 'ریست'
                     }
                    }
                    className="admin-course-table"
                    loading={dataLoading}
                    onChange={onChangeTable}
                    scroll={{x: 750}}
                    pagination={{
                    current: data?.number ? data?.number + 1 : 1,
                    pageSize: params.pageSize,
                    total: data?.totalElements
                }}
                    style={{marginTop: "20px"}}
                    columns={columns}
                    dataSource={data?.content}
                    size="middle"/>
                <Modal
                    title="توضیحات"
                    centered
                    open={show}
                    onOk={() => {
                    }}
                    onCancel={() => {
                        setShow(false);
                    }}
                    footer={[]}
                    bodyStyle={{maxHeight: "700px", overflow: 'auto'}}
                    width={720}
                >
                    <p style={{textAlign: "justify", whiteSpace: 'pre-line'}}>{selectedDescription}</p>
                </Modal>
                {deleteModalContextHolder}
            </Wrapper1>
        </>

    );
}